import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Sentry } from '@martha-v5/sentry/browser';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onReset?: () => void;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class PageErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[PageErrorBoundary]', error, info);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info.componentStack ?? '' } },
      tags: { boundary: 'page' },
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h3>Something went wrong</h3>
          <p style={{ color: '#888', marginBottom: '1rem' }}>{this.state.error?.message}</p>
          <button onClick={() => { this.setState({ hasError: false, error: null }); this.props.onReset?.(); }}>
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
